import BlogDetailsContainer from "../../Componant/Blog/BlogDetails";

const BlogDetails = () => {
  return (
    <div className="page-body">
      <BlogDetailsContainer />
    </div>
  );
};

export default BlogDetails;
